import { Routes } from '@angular/router';
import { candidateAuthGuard } from './core/guards/candidate-auth.guard';
import { candidateGuestGuard } from './core/guards/candidate-guest.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/public/pages/jobs-list-page/jobs-list-page.component').then((m) => m.JobsListPageComponent),
  },
  {
    path: 'jobs/:id',
    loadComponent: () =>
      import('./features/public/pages/job-detail-page/job-detail-page.component').then((m) => m.JobDetailPageComponent),
  },
  {
    path: 'login',
    canActivate: [candidateGuestGuard],
    loadComponent: () =>
      import('./features/public/pages/login-page/login-page.component').then((m) => m.LoginPageComponent),
  },
  {
    path: 'register',
    canActivate: [candidateGuestGuard],
    loadComponent: () =>
      import('./features/public/pages/register-page/register-page.component').then((m) => m.RegisterPageComponent),
  },
  {
    path: 'forgot-password',
    canActivate: [candidateGuestGuard],
    loadComponent: () =>
      import('./features/public/pages/forgot-password-page/forgot-password-page.component').then(
        (m) => m.ForgotPasswordPageComponent,
      ),
  },
  {
    path: 'reset-password',
    canActivate: [candidateGuestGuard],
    loadComponent: () =>
      import('./features/public/pages/reset-password-page/reset-password-page.component').then(
        (m) => m.ResetPasswordPageComponent,
      ),
  },
  {
    path: 'portal',
    canActivate: [candidateAuthGuard],
    loadComponent: () =>
      import('./shared/components/candidate-shell/candidate-shell.component').then((m) => m.CandidateShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'profile',
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/portal/pages/profile-page/profile-page.component').then((m) => m.ProfilePageComponent),
      },
      {
        path: 'applications',
        loadComponent: () =>
          import('./features/portal/pages/applications-page/applications-page.component').then(
            (m) => m.ApplicationsPageComponent,
          ),
      },
      {
        path: 'applications/:id',
        loadComponent: () =>
          import('./features/portal/pages/application-detail-page/application-detail-page.component').then(
            (m) => m.ApplicationDetailPageComponent,
          ),
      },
      {
        path: 'interviews',
        loadComponent: () =>
          import('./features/portal/pages/interviews-page/interviews-page.component').then(
            (m) => m.InterviewsPageComponent,
          ),
      },
      {
        path: 'offers',
        loadComponent: () =>
          import('./features/portal/pages/offers-page/offers-page.component').then((m) => m.OffersPageComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
